import { Login } from "pages/Login/Login";

export default Login;
